<template>
    <div class="wrap">
        <div class="container lnb" style="position: relative;height: calc(100vh - 70px);overflow: scroll">
            <div class="contents_wrap" style="height: auto">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <magazine-write-component :magazineType="'createMagazine'"></magazine-write-component>
                </div>
            </div>
            <div class="" style="text-align: center;">
                <el-button @click="submitForm()" type="primary">저장</el-button>
            </div>
            <page-footer></page-footer>
        </div>
        <item-select-modal></item-select-modal>
        <magazine-fitting-edit-modal></magazine-fitting-edit-modal>
        <item-one-select-modal></item-one-select-modal>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import MagazineWriteComponent from "@/components/magazine/MagazineWriteComponent";
import ItemSelectModal from "@/components/modal/ItemSelectModal.vue";
import MagazineFittingEditModal from "@/components/modal/MagazineFittingEditModal.vue";
import ItemOneSelectModal from "@/components/modal/ItemOneSelectModal.vue";
export default {
    name: 'ThemeWrite',
    components: {
        MagazineWriteComponent,
        ItemSelectModal,
        MagazineFittingEditModal,
        ItemOneSelectModal,
    },
    mixins: [],
    data() {
        return {
            p_idx: this.$route.params.p_idx,
            magazineKey: this.$route.params.p_idx,
        }
    },
    mounted() {
    },
    methods: {
        submitForm() {
            //EventBus.$emit('updateMagazinForm');
            EventBus.$emit('writeMagazine');
        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>

</style>
